import { HttpHeaders } from '@angular/common/http';
import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Injector, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { environment } from '@environments/environment';
import { Constants } from '@shared/models/common/constants';
import { BreadcrumbService } from '@shared/services/breadcrumb.service';
import { CacheService } from '@shared/services/cache.service';
import { LanguageService } from '@shared/services/language.service';
import { SearchResultsCacheService } from '@shared/services/search-results-cache.service';
import * as moment from 'moment';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { Utils } from '../../core/utilities/utils';
import { DialogService } from '../services/dialog.service';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-base',
  template: ``
})
// this class is used as base component for all components
export abstract class BaseComponent implements OnInit, OnDestroy {

  @ViewChild('top', { static: true }) top: any;

  // tslint:disable-next-line: no-output-on-prefix
  @Output() onUpdate = new EventEmitter();

  lang$: Observable<string>;

  // this is an observable reserved for a spinner when loading
  isLoading$ = new Subject();

  // alive is used to kill component level subscriptions
  alive = true;

  // this subscription is reserved in case certain tricky case requires it, use alive if not needed
  subscription = new Subscription();

  // commonly injected services
  languageService: LanguageService;
  cacheService: CacheService;
  searchResultsCache: SearchResultsCacheService;
  breadcrumbService: BreadcrumbService;
  changeDetectorRef: ChangeDetectorRef;
  dialogService: DialogService;
  elementRef: ElementRef;
  router: Router;
  clipboard: Clipboard;

  constructor(injector: Injector) {
    this.languageService = injector.get(LanguageService);
    this.cacheService = injector.get(CacheService);
    this.searchResultsCache = injector.get(SearchResultsCacheService);
    this.breadcrumbService = injector.get(BreadcrumbService);
    this.changeDetectorRef = injector.get(ChangeDetectorRef);
    this.dialogService = injector.get(DialogService);
    this.elementRef = injector.get(ElementRef);
    this.router = injector.get(Router);
    this.clipboard = injector.get(Clipboard);
  }

  // call this in children component's ngOnInit lifecycle
  ngOnInit() {
    this.bindAppLevelObservables();
  }

  // call this in children component's ngOnDestroy lifecycle
  ngOnDestroy() {
    this.breadcrumbService.removeBreadcrumb();

    this.alive = false;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  //ODS Required Scripts
  loadOntarioExpandCollapse() {
    if(document.getElementById('ontario-expand-collapse')) {
      document.getElementById('ontario-expand-collapse').remove();
    }

    let body = <HTMLDivElement>document.body;
    let script = document.createElement("script");
    script.innerHTML = "";
    script.id = "ontario-expand-collapse";
    script.src =
      "../../../../assets/ontario-design-system/scripts/ontario-expand-collapse.js";
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }

  loadOntarioA11y() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement("script");
    script.innerHTML = "";
    script.src =
      "../../../../assets/ontario-design-system/scripts/ontario-a11y.js";
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }

  loadOntarioHeader() {
    let body = <HTMLDivElement>document.body;
    let script = document.createElement("script");
    script.innerHTML = "";
    script.src =
      "../../../../assets/ontario-design-system/scripts/ontario-header.js";
    script.async = true;
    script.defer = true;
    body.appendChild(script);
  }
  //ODS Required Scripts

  cd() {
    this.changeDetectorRef.markForCheck();
  }

  // children component override this function to syncronize data with server
  syncData(): Observable<any> | void { return of(undefined); }

  // this function wraps any data into an Observable for template to consume
  observable(data: any): Observable<any> {
    return of(data);
  }

  get httpOptions(): any {
    return {
      headers: new HttpHeaders({
        // "Content-Type": "application/json",
        // Authorization:
          // "Basic " + btoa(environment.username + ":" + environment.password),
          "Ocp-Apim-Subscription-Key" : environment.serviceSubscriptionKey
      }),
    };
  }

  valueOf(form: FormGroup, prop: string) {
    return form?.get(prop)?.value;
  }

  // bind to the app level observables
  private bindAppLevelObservables() {
    this.lang$ = this.languageService.languageType$;
  }

  // constants getter
  get constants() {
    return Constants;
  }

  // utility getter
  get utils() {
    return Utils;
  }

  get now() {
    return moment();
  }

  get uuid() {
    return Utils.uuid();
  }

  copyMetadataUrl(index: string, fileNumber: string){
    var url = environment.application_url + 
              "persistent-linking?" + 
              index + "=" +
              fileNumber;
    this.clipboard.copy(url);
  }

}
